import {CommonModule} from '@angular/common';
import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router, RouterModule} from '@angular/router';
import {NgIconsModule} from '@ng-icons/core';
import {TranslateModule} from '@ngx-translate/core';
import {InfoComponent} from '../../components/info/info.component';

@Component({
  selector: 'app-error-message',
  imports: [ CommonModule, TranslateModule, RouterModule, InfoComponent, NgIconsModule],
  templateUrl: './error-message.component.html'
})
export class ErrorMessageComponent {

  @Input() errorTitle: string = '';
  @Input() errorMessage: string = '';
  @Input() route: string = '';

  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ErrorMessageComponent>
  ) {
    // Si se pasan datos desde el diálogo, usarlos en lugar de los inputs
    if (data) {
      this.errorTitle = data.errorTitle || this.errorTitle;
      this.errorMessage = data.errorMessage || this.errorMessage;
      this.route = data.route || this.route;
    }
  }

  closeDialog(value: boolean): void {
    if (value) {
      this.router.navigate([this.route]);
      this.dialogRef.close(value);
    } else {
      this.dialogRef.close(value);
    }
  }

}
